import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IMetaPage } from '@feathr/blackbox';
import { ConnectionCard } from '@feathr/components';

interface IMetaInstagramAccountsCardProps {
  pages: IMetaPage[];
}

function getInstagramUrl(username: string): string {
  return `https://instagram.com/${username}`;
}

function MetaInstagramAccountsCard({
  pages,
}: Readonly<IMetaInstagramAccountsCardProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <ConnectionCard name={'meta-instagram-accounts-card'}>
      <ConnectionCard.Header count={pages.length} icon={faInstagram} iconTheme={'pink'}>
        {t('Instagram Accounts')}
      </ConnectionCard.Header>
      <ConnectionCard.Items>
        {pages.map((page) => (
          <ConnectionCard.Item
            href={getInstagramUrl(page.instagram_username ?? page.instagram_account_id!)}
            key={page.instagram_account_id}
          >
            {page.instagram_username || page.name}
          </ConnectionCard.Item>
        ))}
      </ConnectionCard.Items>
    </ConnectionCard>
  );
}

export default MetaInstagramAccountsCard;
